import React from 'react';
import { transactions as types } from '../../../../../../types';
import { Root, ColStyled, RowStyled } from './styled';

const WithdrawInfo = ({ curData }: { curData: types.TTransactions }) => {
    return (
        <Root>
            <RowStyled>
                <ColStyled>
                    <span>User</span>
                    <span>{curData.nexId}</span>
                </ColStyled>
            </RowStyled>
            <RowStyled>
                <ColStyled>
                    <span>Withdraw amount</span>
                    <span>{curData.amount}</span>
                </ColStyled>
            </RowStyled>
            <RowStyled>
                <ColStyled>
                    <span>Balance</span>
                    <span>{curData.meta.walletBalance}</span>
                </ColStyled>
            </RowStyled>
            <RowStyled>
                <ColStyled>
                    <span>Turnover</span>
                    <span>{curData.meta.turnover}</span>
                </ColStyled>
            </RowStyled>
            <RowStyled>
                <ColStyled>
                    <span>Bank name</span>
                    <span>{curData.meta.bankName}</span>
                </ColStyled>
            </RowStyled>
            <RowStyled>
                <ColStyled>
                    <span>Account name</span>
                    <span>{curData.meta.accountName}</span>
                </ColStyled>
            </RowStyled>
            <RowStyled>
                <ColStyled>
                    <span>Account number</span>
                    <span>{curData.meta.accountNumber}</span>
                </ColStyled>
            </RowStyled>
        </Root>
    );
};

export default WithdrawInfo;
